import React, { FC } from "react";
import Row from "../../Fundamentals/Grid/Row";
import Column from "../../Fundamentals/Grid/Column";
import ProductHighlight, { IProductHighlightProps } from "./ProductHighlight";

export interface IProductHighlightsProps {
  /**
   * List on info items
   */
  highlights: IProductHighlightProps[];
}

const ProductHighlights: FC<IProductHighlightsProps> = ({ highlights }) => (
  <Row data-testid="ProductHighlights">
    {highlights?.map((item) => (
      <Column key={item.id} xl={4} md={6} classes={{ root: "mb-8 mb-md-10" }}>
        <ProductHighlight {...item} />
      </Column>
    ))}
  </Row>
);

export default ProductHighlights;
